import Vue from 'vue'
import App from './app.vue'
import router from './src/router'
import Vant from 'vant'
import appSet from './src/utils/config'
import store from './src/store'
import Sensors from '../static/utils/Sensors.js'
import '../utils/wxobs'

import 'vant/lib/index.css'
import './src/utils/flexible/index.js'

Vue.use(Vant)
Vue.prototype.$sensors = new Sensors(0)

appSet()

if (process.env.NODE_ENV !== 'production') {
  const VConsole = require('vconsole')
  /* eslint-disable no-new */
  new VConsole()
}

// 路由统计
router.afterEach((to, from) => {
  Vue.prototype.$sensors.autoTrackSinglePage()
})

new Vue({
  el: '#app',
  router,
  store,
  render: h => h(App)
})
